import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl mb-4">At Home Mud Bath</h3>
            <p className="text-white/80 font-light leading-relaxed">
              Bringing the luxury spa experience to your home with our premium mud bath and soap products.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-white/80 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/#products" className="text-white/80 hover:text-white transition-colors">
                Products
              </Link>
              <Link to="/account" className="text-white/80 hover:text-white transition-colors">
                My Account
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-4">Contact Us</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@athomemudbath.com" className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                hello@athomemudbath.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} At Home Mud Bath. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
